module.exports = __webpack_public_path__ + "img/logo.24ec3b62.png";